import React, { useState, useEffect, useCallback } from 'react';
// import { getMyPlans } from '../../actions/userActions';
import { handleActivation, getMyLicenses, handleUpdateActivation } from '../../../actions/license';
import '../styles.css';
import { toast } from 'react-toastify';
import { dateFormat } from '../../../utils';
import CreateRoom from './createRoom';
import LoadingView from '../../Loader/LoadingView';
import { useHistory } from 'react-router-dom';
// import EditIcon from '@mui/icons-material/Edit';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import BackIcon from '../../../images/back-icon.png';
import LicenseModal from '../../Dashboard/components/ProductModel';

const PlanA = (props) =>
{
	const history = useHistory();
	const { planId, setPack } = props;
	const [ data, setData ] = useState({ loading: true, licenses: [] });
	const [ isOpen, setOpen ] = useState({ status: false, type: null, data: null });
	const [ model, setModel ] = useState(false);
	const [ id, setId ] = useState('');

	const getData = () =>
	{
		setData((prevState) => { return { ...prevState, loading: true }; });
		getMyLicenses(planId).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res ==== ', res);
			if (res && res.status)
			{
				setData({ loading: false, licenses: [ ...res.data.data ] });
			}
			else
			{
				setData({ loading: false, licenses: [] });
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				setData({ loading: false, licenses: [] });
			});
	};

	useEffect(() =>
	{
		getData();
	}, []);

	const handleActivate = useCallback((roomName) =>
	{
		const body = {
			planId,
			roomName,
			type : isOpen.type
		};

		// eslint-disable-next-line no-console
		// console.log('body', body);
		handleActivation(body).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res handle Activation', res);
			if (res.data && res.data.status)
			{
				toast.success(res?.data?.message);
				setOpen({ status: false, type: null, data: null });
				history.push(`/meet/${res?.data?.data?._id}`);
				// getData();
			}
			else
			{
				toast.error(res?.data?.message);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal Server Error, Please try again');
			});
	}, [ planId, isOpen ]);

	const loadMonths = (type, c, cls) =>
	{
		const licensesData = data.licenses.filter((item) => item.type === type).slice(0, c);

		const ele = licensesData.map((item, i) =>
		{
			return (
				<div key={`${type}_${i}`} className='col-12 col-sm-6'>
					<div className={`flexCol text-center col-6 alignCntr ${cls} brdrRadiusSM whiteTxt pdngXXS margXS purchaseCard`}>
						<span>{item.name}</span>
						{item.expireDate >= new Date().valueOf() ?
							<span>Valid till : {dateFormat(item.expireDate)}</span> :
							<span>Expired</span>}
						{item.expireDate >= new Date().valueOf() &&<div className='displayHover' >
							<div className='d-flex w-100 justifyBtwn' >
								<div className='d-flex flex-column px-3 w-50 resAlignCntr' onClick={() => setOpen({ status: true, type: type, data: item })}>
									<EditOutlinedIcon/>
									<span>Edit</span>
								</div>
								<div className='d-flex flex-column px-3 w-50 resAlignCntr' onClick={() => { setId(item._id); setModel(true); }}>
									<VisibilityOutlinedIcon/>
									<span>View</span>
								</div>
							</div>
						</div>}
					</div>
				</div>);
		});

		let i = ele.length;

		while (i < c)
		{
			const n = i === 0 ? '1st' : i === 1 ? '2nd' : i === 2 ? '3rd' : `${i+1}th`;

			ele.push(
				<div className='col-12 col-sm-6'>
					<div key={`${type}_${i}`} title={`Activate ${n} Month`} className={`flexCol alignCntr ptr ${cls} brdrRadiusSM whiteTxt pdngXXS margXS`} onClick={() => setOpen({ status: true, type, data: null })}>
						<span>{`${n} Month`}</span>
					</div>
				</div>
			);
			i++;
		}

		return ele;
	};

	const loadECRMonths = (f, t) =>
	{
		const _data = data.licenses.filter((item) => item.type === 'BPCR');

		const licensesData = _data.slice(f, t+1);

		const ele = licensesData.map((item, i) =>
		{

			return (
				<div key={`BPCR_${i}`} className='col-12 col-sm-6'>
					<div className='w-100 text-center linearGradientOrange brdrRadiusSM whiteTxt purchaseCard'>
						<span>{item.name}</span> <br/>
						{item.expireDate >= new Date().valueOf() ?
							<span>Valid till : {dateFormat(item.expireDate)}</span> :
							<span>Expired</span>}
						{item.expireDate >= new Date().valueOf() &&<div className='displayHover' >
							<div className='d-flex w-100 justifyBtwn' >
								<div className='d-flex flex-column px-3 w-50 resAlignCntr' onClick={() => setOpen({ status: true, type: 'BPCR', data: item })}>
									<EditOutlinedIcon/>
									<span>Edit</span>
								</div>
								<div className='d-flex flex-column px-3 w-50 resAlignCntr' onClick={() => { setId(item._id); setModel(true); }}>
									<VisibilityOutlinedIcon/>
									<span>View</span>
								</div>
							</div>
						</div>}
					</div>
				</div>
			);
		});

		let i = ele.length + f;

		while (i <= t)
		{
			const n = i === 0 ? '1st' : i === 1 ? '2nd' : i === 2 ? '3rd' : `${i+1}th`;

			ele.push(
				<div className='col-12 col-sm-6'>
					<div
						key={`BPCR_${i}`}
						title={`Activate ${n} Month`}
						className='w-100 py-2 text-center linearGradientOrange brdrRadiusSM whiteTxt'
						onClick={() => setOpen({ status: true, type: 'BPCR', data: null })}
					>
						<span>{`${n} Month`}</span>
					</div>
				</div>
			);
			i++;
		}

		return ele;
	};

	const handleClose = useCallback(() =>
	{
		setOpen({ status: false, type: null, data: null });
	}, []);

	const handleUpdate = useCallback((obj) =>
	{
		const body = {
			id   : obj.id,
			name : obj.name
		};

		handleUpdateActivation(body).then((res) =>
		{
			// eslint-disable-next-line no-console
			// console.log('res handle Activation', res);
			if (res.data && res.data.status)
			{
				toast.success(res?.data?.message);
				setOpen({ status: false, type: null, data: null });
				getData();
			}
			else
			{
				toast.error(res?.data?.message);
			}
		})
			.catch((err) =>
			{
				// eslint-disable-next-line no-console
				console.log('err ==== ', err);
				toast.error('Internal Server Error, Please try again');
			});

	}, []);

	return (
		<div className='flexCol position-relative alignCntr baseBg fullHeight pdngXS dashboardCntnr'>
			{/* <div className='flexCol alignCntr whiteTxt
			LinearGradientGreen brdrRadiusSM pdngXS'>
				<h3 className='fontWeightNormal textCntr'>FEATURES OF EACH CONFERENCE ROOM PURCHASED</h3>
			</div> */}
			{setPack?
				<img className='backIcon' onClick={() => setPack('')} src={BackIcon} alt='Back'/>
				:null}

			{data?.loading && <LoadingView />}
			<span className='textCntr pdngVSM bold'>1 KONX PACK FOR $250</span>
			<div className='resRowCol'>
				<div className='flexMinWidthCol alignCntr pdngSM'>
					<div className='flexCol alignCntr fullHeight width80' >
						<div className='flexCol alignCntr linearGradientBlue brdrRadiusSM whiteTxt pdngSM'>
							{/* <span>Business Conference Room</span> */}
							<span>Personal Conference Room</span>
						</div>
						<div className='flexCol alignCntr mt-3 bold text-center'>
							{/* <ul className='flexCol alignCntr featuresCntnr'>
								<li className='flexRow justifyCntr features textCntr'> */}
							<p className='fs-16'>	7 Months of Personal Conference Room</p>
							{/* </li>
								<li className='flexRow justifyCntr  textCntr'> */}
							<p className='fs-16'>	Up to 25 Participants / Meeting</p>
							{/* </li>
								<li className='flexRow justifyCntr  textCntr'> */}
							<p className='fs-16'>	Good For 25 Hours / Month</p>
							{/* </li>
							</ul> */}
						</div>
						{/* <div className='flexCol halfWidth '>
							{loadMonths('BCR', 3, 'linearGradientBlue')}
						</div> */}
						<div className='row mt-3 w-100'>
							{loadMonths('PCR', 7, 'linearGradientBlue')}
							{/* <div className='flexMinWidthCol pdngXXS'>
								{loadMonths('PCR', 7, 'linearGradientBlue')}
							</div> */}
						</div>
					</div>
				</div>
				<div className='flexMinWidthCol justifyBtwn alignCntr pdngSM'>
					<div className='flexCol alignCntr fullHeight width80'>
						<div className='flexCol alignCntr linearGradientOrange brdrRadiusSM whiteTxt pdngSM'>
							{/* <span>Enterprise Conference Room</span> */}
							<span>Basic PRO Conference Room</span>
						</div>
						<div className='flexCol alignCntr bold text-center mt-3'>
							<p className='fs-16'> 6 Months of Basic PRO Conference Room</p>
							<p className='fs-16'> 	Up to 300 Participants / Meeting</p>
							<p className='fs-16'> 	 Good For 70 Hours / Month</p>
						</div>
						<div className='row mt-3 w-100'>
							{/* <div className=''> */}
							{loadECRMonths(0, 5)}
							{/* </div> */}
							{/* <div className='flexMinWidthCol pdngXXS'>
								{loadECRMonths(4, 5)}
							</div> */}
						</div>
					</div>
				</div>
				<div className='flexMinWidthCol alignCntr pdngSM'>
					<div className='flexCol alignCntr fullHeight width80'>
						<div className='flexCol alignCntr LinearGradientGreen brdrRadiusSM whiteTxt pdngSM'>
							{/* <span>Corporate Conference Room</span> */}
							<span>Enterprise Conference Room</span>
						</div>
						<div className='flexCol alignCntr text-center mt-3 bold'>
							<p className='fs-16'> 1 Month of Enterprise Conference Room</p>
							<p className='fs-16' >Up to 1000 Participants / Meeting</p>
							<p className='fs-16'>	 Good For 80 Hours / Month</p>
						</div>
						{/* <div className='flexCol halfWidth'>
							{loadMonths('CCR', 5, 'LinearGradientGreen')}
						</div> */}
						<div className='row mt-3 w-100'>
							{loadMonths('ECR', 1, 'LinearGradientGreen')}
							{/* <div className='flexMinWidthCol pdngXXS'>
								{loadMonths('BACR', 3, 'LinearGradientGreen')}
							</div> */}
						</div>
					</div>
				</div>
				{isOpen?.status &&
					<CreateRoom
						open={isOpen?.status} handleClose={handleClose} handleSave={handleActivate}
						data={isOpen.data ? isOpen.data : null}
						handleUpdate={handleUpdate}
						name={isOpen.type === 'BCR' ? 'Business' : isOpen.type === 'CCR' ? 'Corporate' : isOpen.type === 'ECR' ? 'Enterprise' : ''}
					/>
				}
			</div>
			<LicenseModal open={model} handleClose={() => setModel(false)} id={id}/>
			{/* <div className='flexCol whiteTxt LinearGradientGreen brdrRadiusSM pdngSM mrgnTSM'>
				<h3 className='pdngXXS'>www.konx.biz</h3>
			</div> */}
		</div>
	);
};

export default PlanA;